module.exports = __webpack_public_path__ + "static/img/Hato-Selfridges-ON-PRESS-3600-6R9A3308.eb558f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workshops/Hato-Selfridges-ON-PRESS-3600-6R9A3308.jpg
// module id = 177
// module chunks = 1